import config from "../config";

// Mirrors ResortDetailsService.jsx's safeFetch convention.
const safeFetch = async (url, options = {}) => {
  const res = await fetch(url, {
    ...options,
    headers: { ...config.getHeaders(), ...options.headers },
  });

  if (!res.ok) {
    const errorText = await res.text();
    console.error("API Error:", errorText);
    let message = errorText;
    try {
      const parsed = JSON.parse(errorText);
      message = parsed.message || parsed.error || errorText;
    } catch {
      // not JSON - fall back to raw text
    }
    throw new Error(message || "API request failed");
  }

  if (res.status === 204) {
    return null;
  }

  const contentType = res.headers.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    return null;
  }
  return res.json();
};

export const fetchBlogPosts = async () => {
  return safeFetch(`${config.BASE_URL}/api/blog`);
};

export const fetchBlogPostById = async (id) => {
  return safeFetch(`${config.BASE_URL}/api/blog/${id}`);
};

export const createBlogPost = async (payload) => {
  return safeFetch(`${config.BASE_URL}/api/blog`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
};

export const updateBlogPost = async (id, payload) => {
  return safeFetch(`${config.BASE_URL}/api/blog/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
};

export const updateBlogPostStatus = async (id, status) => {
  return safeFetch(`${config.BASE_URL}/api/blog/${id}/status`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ status }),
  });
};

export const deleteBlogPost = async (id) => {
  return safeFetch(`${config.BASE_URL}/api/blog/${id}`, { method: "DELETE" });
};

/**
 * Multipart upload - deliberately does NOT use safeFetch/config.getHeaders()
 * (that always forces Content-Type: application/json, which would break the
 * multipart boundary the browser needs to set itself for FormData). Mirrors
 * ResortDetailsService.jsx's uploadPhoto.
 */
export const uploadBlogCoverImage = async (id, file) => {
  const token = localStorage.getItem("token");
  const formData = new FormData();
  formData.append("file", file);
  const res = await fetch(`${config.BASE_URL}/api/blog/${id}/cover-image`, {
    method: "POST",
    headers: { Authorization: token ? `Bearer ${token}` : "" },
    body: formData,
  });
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(errorText || "Upload failed");
  }
  return res.json();
};

export const deleteBlogCoverImage = async (id) => {
  return safeFetch(`${config.BASE_URL}/api/blog/${id}/cover-image`, { method: "DELETE" });
};

// Relative path (e.g. "public/blog/12/uuid.jpg") -> displayable URL - same
// public, unauthenticated media convention as ResortDetailsService.jsx's
// publicMediaUrl.
export const publicMediaUrl = (relativePath) =>
  relativePath ? `${config.BASE_URL}/api/public-media/${relativePath}` : null;
